import { Component } from '@angular/core';
import { trigger, transition, style, animate } from '@angular/animations';
import { NbDialogRef } from '@nebular/theme';
import { map } from 'rxjs/operators';

import { Location } from '@app/models/locations/locations.model';
import { DeviceService } from '@app/models/devices/devices.service';
import { DataComponent } from '@app/utils/data.component';
import { LocationService } from '@app/models/locations/locations.service';

@Component({
    selector: 'app-location-selector',
    templateUrl: './template.html',
    styleUrls: ['./style.scss'],
    animations: [
        trigger('dialog', [
            transition('void => *', [style({ transform: 'scale3d(.6, .6, .6)' }), animate('100ms 0ms ease-in')]),
            transition('* => void', [animate(100, style({ transform: 'scale3d(.0, .0, .0)' }))]),
        ]),
    ],
})
export class LocationSelectorComponent extends DataComponent<Location> {
    userID: number;
    activeLoc: number;
    LOCATION_SORT: any;

    constructor(
        public dialog: NbDialogRef<LocationSelectorComponent>,
        private devices: DeviceService,
        private locations: LocationService
    ) {
        super();
    }

    fetch() {
        return this.locations.getAll({ list_shared: true, profile: true }).pipe(
            map((data) => this.LOCATION_SORT(data, this.userID)),
            this.devices.joinLocationsPipe()
        );
    }

    selectLocation(loc: Location) {
        this.dialog.close(loc);
    }
}
